var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39779_148750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 42.125C32.0159 42.125 41.25 32.8909 41.25 21.5C41.25 10.1091 32.0159 0.875 20.625 0.875C9.23413 0.875 0 10.1091 0 21.5C0 32.8909 9.23413 42.125 20.625 42.125Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3785 32.7747C19.6969 32.7747 19.0153 32.7747 18.3337 32.7747C17.8712 32.7747 17.5619 32.4766 17.5602 32.0158C17.7294 26.7072 16.6039 27.1125 20.4357 27.1342C24.1175 27.1077 23.0291 26.7475 23.1983 31.9505C23.1983 32.4911 22.9155 32.7747 22.3789 32.7755L20.3785 32.7747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2947 26.0117C19.6276 26.0117 18.9605 26.0069 18.2934 26.0117C17.7488 26.0464 17.6425 25.4252 17.5684 25.0167C17.379 23.2539 18.1122 21.8851 19.4093 20.7572C20.3197 19.8863 21.5653 19.5221 22.5288 18.7358C23.4263 17.9615 23.3345 16.6547 22.3782 15.9667C21.3372 15.2207 19.6808 15.1425 18.6133 15.833C17.8584 16.3631 17.3017 17.1414 16.7039 17.8366C16.351 18.2564 16.0021 18.3015 15.5663 17.9712C14.6505 17.2772 13.7374 16.5809 12.827 15.8821C12.4419 15.5872 12.3912 15.2456 12.6425 14.8347C15.1643 10.2263 21.5757 8.72781 25.7813 11.9344C28.6011 13.7688 29.8459 17.8922 27.6545 20.6726C26.798 21.8811 25.3454 22.4096 24.2086 23.2926C22.6038 24.6421 23.606 25.9118 22.2968 26.0117C21.6297 26.0117 20.9623 26.0117 20.2947 26.0117Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39779_148750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.25,
    height: 41.25,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/ConfirmIcon.e68af46e6261d5096cc4a22748467083.svg";
export { ForwardRef as ReactComponent };